module.exports = __webpack_public_path__ + "static/img/share.4da2d38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/crossYear/stage-03/popup/share.png
// module id = HA0C
// module chunks = 1